<template>
  <!--if logged in-->
  <div v-if="this.getAccessToken  !== null"
       class="modal fade opt_out logged_in" id="opt_out_loggedIn"
       tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
       data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">

      <div class="modal-content step1_opt" :class="step === 1 ? '': 'd-none'">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" @click="closeModal()" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Afmelden</h5>
          <h4>
            Wanneer je je afmeldt voor Prepaid Surprise ontvang je geen speelcodes meer en kun je geen kans meer maken op prijzen. <br>
            Wil je je bij deze afmelden?
          </h4>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <div class="table_prnt">
            <div class="table_chld">
              <button type="button" class="black_secondary_btn" @click="closeModal()">Terug</button>
            </div>
            <div class="table_chld">
              <button type="button" class="black_btn step1"  @click="submitOptOut()">Afmelden</button>
            </div>
          </div>
          <div class="modal-header">
          <h4>
            Wil je je afmelden voor sms marketing? Sms AFMELDEN naar 1616.
          </h4>
          </div>
        </div>
      </div>

      <div class="modal-content step2_opt" :class="step === 2 ? '': 'd-none'">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" @click="closeModal()" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Afmelden voor Prepaid Surprise</h5>
          <h4>
            Je afmelding is gelukt en je MySurprise account is verwijderd. Je zult geen speelcodes meer ontvangen voor Prepaid Surprise. Wil je je later weer aanmelden?<br> Maak dan een nieuw My Surprise account aan.
          </h4>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <button type="button" class="black_btn step1" @click="redirectCustomer()">Afsluiten</button>
        </div>
      </div>

    </div>
  </div>

  <!--if logged out-->
  <div v-else-if="this.getAccessToken  === null"
       class="modal fade opt_out logged_out" id="opt_out_loggedOut"
       tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
       data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content step1_opt" :class="step === 1 ? '': 'd-none'">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" @click="closeModal()" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Afmelden voor Prepaid Surprise</h5>
          <h4>
            Wanneer je je afmeldt voor Prepaid Surprise ontvang je geen speelcodes meer en kun je geen kans meer maken op prijzen. Om je af te melden vul je je mobiele nummer in. Vul ter controle één van de speelcodes in de je de afgelopen tijd hebt gekregen.
          </h4>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input type="tel" class="form-control" id="mobile" v-model="inputMsisdn"
                     name="mobile" placeholder="Je mobiele nummer" required />
              <label v-if="!isValidMsisdn" class="form-control-label" for="mobile">Je mobiele nummer</label>
              <div v-if="!isValidMsisdn" class="error_msg">
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10 cijfers. Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>
            <div :class="{'form-group': true, 'error': !isValidCode}">
              <input type="password"  class="form-control" id="pass"  v-model="inputCode"
                     name="pass" placeholder="De speelcode" required />
              <label  v-if="!isValidCode"  class="form-control-label" for="pass">De speelcode</label>
              <div  v-if="!isValidCode" class="error_msg">Oeps, er ging iets fout. Probeer het later nog eens.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="table_prnt">
            <div class="table_chld">
              <button type="button" class="black_secondary_btn" @click="closeModal()">Terug</button>
              <button type="button" class="black_btn step1"  @click="submitOptOut()">Afmelden</button>
            </div>
          </div>
          <div class="dots-container">
            <div class="dot step1 active"></div>
            <div class="dot step2"></div>
          </div>
        </div>
      </div>

      <div class="modal-content step2_opt" :class="step === 2 ? '': 'd-none'">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" @click="closeModal()" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Afmelden voor Prepaid Surprise</h5>
          <h4  v-if="!isAlreadyOptOut">
            Je afmelding is gelukt. Je zult geen speelcodes meer ontvangen voor Prepaid Surprise. Wil je je later weer aanmelden?<br> Maak dan een nieuw MySurprise account aan.
          </h4>
          <h4 v-if="isAlreadyOptOut">
            Je bent al afgemeld voor Prepaid Surprise. Wil je je later weer aanmelden?<br> Maak dan een nieuw MySurprise account aan.
          </h4>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <button type="button" class="black_btn step1" @click="redirectCustomer()">Afsluiten</button>
          <div class="dots-container">
            <div class="dot step1"></div>
            <div class="dot step2 active"></div>
          </div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
  import router from "../../router";
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import gtm_analytics from "../../common/mixin/gtm_analytics";

    export default {
        name: "OptOut",
      mixins:[
        gtm_analytics
      ],
        data(){
          return{
            inputMsisdn: null,
            step:1,
            msisdn: null,
            isValidMsisdn: true,
            inputCode:'',
            isValidCode: true,
            isAlreadyOptOut:false
          }
        },

        computed: {
          ...mapGetters([
            'getAccessToken',
            'getMsisdn',
            'getOptOutResponse'
          ])
        },

        mounted() {
          if(this.getAccessToken){
            $('#opt_out_loggedIn').modal('show')
          }else{
            $('#opt_out_loggedOut').modal('show')
          }
          this.pushPopUp('Popup visit','Opt Out Pop Up')
        },

        methods:{
          ...mapMutations([
            'updateOptOutModal',
            'updateAccessToken'
          ]),

          ...mapActions([
            'optOutCustomer'
          ]),

          closeModal(){
            if(this.getAccessToken){
              $('#opt_out_loggedIn').modal('hide')
            }else{
              $('#opt_out_loggedOut').modal('hide')
            }
            this.updateOptOutModal(false)
          },

          resetValidityFlags(){
            this.isValidMsisdn = true
            this.isValidCode = true
          },

          submitOptOut(){
            const payload ={
              msisdn:  (this.getAccessToken) ? this.getMsisdn  : this.inputMsisdn ,
              code: (this.getAccessToken) ? '' :  this.inputCode,
              loggedIn: (this.getAccessToken) ? true :  false
            }
            this.resetValidityFlags()
            this.optOutCustomer(payload)
              .then(() => {

                if(this.getOptOutResponse.failReason == "CUSTOMER_NOT_FOUND")
                  this.isValidMsisdn = false

                if(this.getOptOutResponse.failReason == "CODE_NOT_EXISTS")
                  this.isValidCode = false

                if(this.getOptOutResponse.failReason == "ALREADY_OPTOUT")
                {
                  this.isAlreadyOptOut = true
                  this.step = 2
                }

                if(this.getOptOutResponse.result == "SUCCESS")
                  this.step = 2

              })
          },

          logOut(){
            this.updateAccessToken(null)
            localStorage.removeItem('accessToken');
            router.push({name: 'Home'})
          },

          redirectCustomer(){
            this.closeModal()
            if(this.getAccessToken){
              this.logOut()
              router.push({name: 'Home'})
            }

          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/OptOut.vue